let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("29nzt")).then(() => parcelRequire('8Nmv9'));